import script from "./MaintenanceOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./MaintenanceOverlay.vue?vue&type=script&setup=true&lang=js"

import "./MaintenanceOverlay.vue?vue&type=style&index=0&id=58e58131&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e58131"]])

export default __exports__